import { Card, Grid, Typography, Tooltip, Chip, Button, Link } from "@mui/material"
import { ToolTipWidget } from "../../incentive-hub/component/TooltipWidget/ToolTip";
import { IncentiveHubProduct } from "../../incentive-hub/types";
import productDataSource from "../../../../main/webapp/WEB-INF/data/IncentiveHubProductsCrosswalk.json";
interface ResultCardProps{
    product: string,
    incentiveAmount: string,
    incentiveType: string,
    partnerName : string,
    customerHotline: string,
    programWebAddress: string, 
    startDate: string, 
    endDate: string,
    description: string,
    productDetail: string
    isIncomeQualified : boolean | undefined
    commercialOrResidential: string
    partnerCategory: string
    queryparams?: string
    incentiveId?: string
    deliveryMechanic? : string
}

export const RebateResultCard = ({product, incentiveAmount, incentiveType,partnerName, customerHotline, programWebAddress, startDate, endDate, description, productDetail, isIncomeQualified, commercialOrResidential, partnerCategory,queryparams, incentiveId, deliveryMechanic} : ResultCardProps) => {

    const updateNumericAmountValuesIfMatched = (amount : string) => {
        var regExp = new RegExp("^\\d+(?:[,.]\\d+)?(?!(?:%))|\\d+\\.{1}[0-9]{2}?$");
        let match = regExp.test(amount)
        if(match && amount[2] !== "%"){
            amount = "$"+incentiveAmount
        }
        else if(amount == "30% of cost"){
            amount = "Up to 30% of cost"
        }
        else{
            amount = amount
        }
        return amount
    }
    const getIncentiveHubProduct = (product: string) => {
        const incentiveHubProduct: IncentiveHubProduct | undefined = productDataSource.find((p : IncentiveHubProduct) => p.rebatefinderUniqueNames.includes(product)) as IncentiveHubProduct | undefined;
        if (incentiveHubProduct) {
            return incentiveHubProduct.productUniqueName;
        }
    }

    const getProductText = (product: string, detail : string) => {
        if(detail !== "All") {
           return `${product} - ${detail}`; 
        }else{
            return product;
        }
            
    }

    // const buildTypeMechanicDisplay = (type: string, mechanic: string) => {
    //     if (mechanic) {
    //         return `${type} : ${mechanic}`;
    //     } else {
    //         return type;
    //     }
    // }


    return(
    <Card sx={{ backgroundColor: '#ffff', padding: { md: '20px', xs: '14px' }, border: '1px solid lightgray' }} id='scrollHere'>
    <Grid container spacing={2} >
      <Grid item xs={12} sm={12} md={8}>
            <Typography variant='body1' sx={{ fontSize: '1.4em !important', fontWeight: 550 }}>{getProductText(product, productDetail)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ textAlign: { md: 'right', xs: 'left' } }}>
            <Typography variant='h6' sx={{ color: '#646769', fontWeight: 'bold' , marginBottom: -3}}>{updateNumericAmountValuesIfMatched(incentiveAmount)}</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} sx={{marginTop: {md : 1, xs: 2.5}}}>
            {incentiveType.includes("||")  ?
            incentiveType.split("||").map((type, index) => (
                <ToolTipWidget key={index} incentiveType={type.trim()}>
                    <Chip sx={index === 0 ? {borderRadius: 0, marginRight: 1} : {borderRadius: 0, marginRight: 1, marginTop:{md: 0, xs: 1}}} label={<Typography>{type.trim()}</Typography>} />
                </ToolTipWidget>
            )): (
                <ToolTipWidget key={0} incentiveType={incentiveType}>
                    <Chip sx={{borderRadius: 0}} label={<Typography>{incentiveType}</Typography>} />
                </ToolTipWidget>
            )}
        </Grid>

        <Grid item xs={12} sm={12} md={6} sx={{marginTop: {md : 1, xs: 2.5}, textAlign: "right"}}>

                {product.includes("Commercial") || commercialOrResidential === "Commercial" ? <Chip sx={{borderRadius: 0, }} label={<Typography  >Commercial</Typography>} /> : null }
                {isIncomeQualified ? <Chip sx={{borderRadius: 0, }} label={<Typography  >Income Qualified</Typography>} /> : null}
        </Grid>
           <Grid item xs={12} sm={12} md={9}>
            <Typography variant='h5' sx={{ paddingLeft: "3px", color: '#646769', fontWeight: 400, paddingTop: -1, paddingBottom: 1  }}>{partnerName}</Typography>
        </Grid>
{/*         
        <Grid item xs={12} sm={12} md={9}>
            <Typography variant='h5' sx={{ paddingLeft: "3px", color: '#646769', fontWeight:400, paddingTop: 1, paddingBottom: 1,fontSize: {md: "1em", xs: '1em'}  }}>{customerHotline ?? null} {programWebAddress !== "" ? " | " : null}<Link href={programWebAddress} sx={{textDecoration: 'underline !important', fontSize: {md: "1em", xs: '1em'}}}>{programWebAddress !== "" ? programWebAddress : null}</Link> </Typography>
        </Grid> */}
       
        <Grid item xs={12} sm={6} md={8}>
            <Typography variant='body1' sx={{ fontSize: '1.05em', fontWeight: 500  }}>{description}</Typography> 
        </Grid>
    <Grid item xs={12} sm={6} md={4} sx={{ textAlign: { md: 'right', xs: 'center' } }}>                                 
            <Button variant="contained" size='small' href={partnerCategory !== "State Government" ? programWebAddress : `https://www.energystar.gov/productfinder/homesavings/redirect/${incentiveId}?${queryparams?.substring(queryparams.indexOf("zip_code_filter"), queryparams.indexOf("zip_code_filter") + 21 ) }`} target="_blank"  sx={{ backgroundColor: '#1F7ABF !important', color: 'white !important', fontSize: "1em !Important", marginBottom: 1 }}>Visit website to learn more</Button>
            {/* <Typography sx={{fontSize: '1em !important'}}>Valid: {startDate} - {endDate}</Typography> */}
        </Grid>
    </Grid>
</Card>
    )

}